import { Component } from 'react';
import { Route, Switch } from 'react-router';
import { Layout } from '../../components/Layout';
import { GlobalSettings } from './Global/GlobalSettings';
import { DeviceSettings } from './Device/DeviceSettings';
import { IqMessengerSettings } from './IqMessenger/IqMessengerSettings';
import { ContactSettings } from './Contact/ContactSettings';
import { ContactGroupSettings } from './ContactGroup/ContactGroupSettings';
import { LicenseOverview } from './Licenses/LicenseOverview';
import { PortalAccessSettings } from './PortalAcces/PortalAccessSettings';
import { NotFound } from '../NotFound';
import { AutoLogoff } from '../../components/AutoLogoff';
import { urls } from '../../logic/urls';

export class Portal extends Component {
    static displayName = Portal.name;
      
    render() {
        return (
            <AutoLogoff>
                <Layout {...this.props} >
                    <Switch>
                        <Route exact path={urls.license} component={LicenseOverview} />
                        <Route exact path={urls.tenant} component={GlobalSettings} />                    
                        <Route exact path={urls.portalAccess} component={PortalAccessSettings} />                  
                        <Route exact path={urls.device} component={DeviceSettings} />
                        <Route exact path={urls.deviceAdd} component={DeviceSettings} />
                        <Route exact path={urls.iqMessenger} component={IqMessengerSettings} />
                        <Route exact path={urls.contact} component={ContactSettings} />
                        <Route exact path={urls.contactGroup} component={ContactGroupSettings} />
                        <Route path='*' component={NotFound}/>
                    </Switch>
                </Layout>
            </AutoLogoff>
        );
    }
}
